export function isNotEmpty(value) {
    return value && value !== 'undefined' ? true : false;
}